"use client";

import { Slash } from "lucide-react";
import React from "react";
import Visibility from "@/components/shared/Visibility";
import Breadcrumb, { useBreadcrumbs } from "@/components/ui/Breadcrumb";
import Button from "@/components/ui/Button";
import DropdownMenu from "@/components/ui/DropdownMenu";

function HeroBreadcrumb() {
  const crumbs = useBreadcrumbs(false);

  return (
    <Breadcrumb>
      <Breadcrumb.List>
        {crumbs.map((crumb, i) => (
          <React.Fragment key={crumb.href}>
            <Breadcrumb.Item>
              {crumb.peers && crumb.peers.length > 0 ? (
                <DropdownMenu>
                  <DropdownMenu.Trigger asChild>
                    <Button.Icon
                      className="text-foreground-secondary"
                      label={crumb.label}
                      icon="chevron-down"
                      orientation="right"
                      variant="link"
                      aria-label="Open dropdown menu"
                    />
                  </DropdownMenu.Trigger>

                  <DropdownMenu.Content>
                    {crumb.peers.map(peer => (
                      <DropdownMenu.Item key={peer.href} asChild>
                        <Button.Link
                          href={peer.href}
                          variant="ghost"
                          className="w-full"
                          aria-label={`Goto ${peer.label} page`}
                        >
                          {peer.label}
                        </Button.Link>
                      </DropdownMenu.Item>
                    ))}
                  </DropdownMenu.Content>
                </DropdownMenu>
              ) : (
                <Breadcrumb.Link asChild>
                  <Button.Link
                    className="text-foreground-secondary"
                    variant="link"
                    href={crumb.href}
                    aria-label={`Goto ${crumb.label} Page`}
                  >
                    {crumb.label}
                  </Button.Link>
                </Breadcrumb.Link>
              )}
            </Breadcrumb.Item>

            <Visibility shouldShow={i < crumbs.length}>
              <Breadcrumb.Separator>
                <Slash className="text-foreground-secondary" />
              </Breadcrumb.Separator>
            </Visibility>
          </React.Fragment>
        ))}
      </Breadcrumb.List>
    </Breadcrumb>
  );
}

export default HeroBreadcrumb;
